import AuthService from './AuthService'

// const auth = new AuthService(process.env.REACT_APP_AUTH_CLIENT_ID, process.env.REACT_APP_AUTH_DOMAIN_ADDRESS)
const auth = new AuthService('pIH4U3IVK5kQlJMqeld6t9Nmc24ta1tI', 'zanzar.auth0.com')

export default auth